export default "__VITE_ASSET__BJTOx$3U__"